import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "../hrmTour.css";

export function startBusinessTripListTour() {
  const steps = [{ popover: { title: "Hướng dẫn nhanh", description: "Giới thiệu luồng quản lý công tác trong HRM.", side: "over", align: "center" } }];
  const segments = [
    ['[data-tour="hrm-business-header"]', "Tiêu đề trang", "Hiển thị tổng số phiếu công tác và nút tour nhanh.", "bottom"],
    ['[data-tour="hrm-business-filter"]', "Bộ lọc công tác", "Lọc dữ liệu, tạo phiếu mới và xuất danh sách.", "bottom"],
    ['[data-tour="hrm-business-pending"]', "Danh sách chờ duyệt", "Khu vực xử lý các phiếu công tác pending.", "top"],
    ['[data-tour="hrm-business-table"]', "Bảng công tác", "Danh sách chi tiết các phiếu công tác theo bộ lọc.", "top"],
  ];
  for (const [selector, title, description, side] of segments) {
    const el = document.querySelector(selector);
    if (!el) continue;
    steps.push({ element: el, popover: { title, description, side } });
  }
  if (steps.length <= 1) return window.alert("Không tìm thấy vùng để chạy hướng dẫn.");
  driver({ showProgress: true, smoothScroll: true, popoverClass: "hrm-tour-popover", nextBtnText: "Tiếp", prevBtnText: "Trước", doneBtnText: "Xong", progressText: "Bước {{current}} / {{total}}", steps }).drive();
}
